import type { OrganizationResponseDto } from '@trellis/api'

export function resolveSmallLogoUrl(
  organization: OrganizationResponseDto | null,
): string | null {
  return organization?.logoSmallUrls?.sm ?? organization?.logoUrls?.sm ?? null
}
